import { TmBaseError } from '@/core/error/tmBaseError'
import type { TmTransportErrorPayload } from './types'

export class TmTransportError<T extends TmTransportErrorPayload = TmTransportErrorPayload> extends TmBaseError<T> {
  public name = 'TmTransportError'
}
